export default "__VITE_ASSET__DbOaauiS__"